export default __webpack_public_path__ + "static/media/arrow_tip.0ee17d5f.svg";